module.exports = __webpack_public_path__ + "img/15.97231df3.jpg";